var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-skeleton-grid"},_vm._l((_vm.numberCards),function(number){return _c('div',{key:number,staticClass:"menu-skeleton-col"},[_c('v-skeleton-loader',{attrs:{"type":"image, article, actions"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }